﻿module Scheduling

open FSharpPlus
open Client
open Feliz
open Feliz.Bulma
open PortalLibs.Client.Util
open Model
open PortalLibs.Shared

let private showDuration { Duration = duration } =
  duration |>> (fun d -> $"%d{d} days") |> Option.emptyStrIfNone
  
let private showSPI { SPI = spi } =
  spi |>> printDecimal |> Option.emptyStrIfNone

let showVariance { ScheduleVariance = variance } =
  variance |>> (float >> formatNumber true MinusSign true AllTwoDigits) |> Option.emptyStrIfNone
  
let jobScheduleView jobSchedule =
  Html.div [
    prop.style [style.custom("marginLeft", "auto"); style.custom("marginRight", "auto")
                style.maxWidth(length.px 800); style.display.flex; style.flexDirection.column]
    prop.children [
      Html.h5 "Job Schedule"
      Bulma.table [
          prop.style [ style.maxWidth(length.px 800); style.alignSelf.flexEnd; Styles.stickyTableBorder ]
          table.isFullWidth
          table.isHoverable
          prop.children [
            Html.thead[
              Html.tr [
                prop.style (Styles.sticky())
                prop.children [
                  Html.th [
                    prop.style[style.textAlign.center; style.width(length.px 140); style.verticalAlign.middle]
                    prop.text "Duration"
                  ]
                  Html.th [
                    prop.style[style.textAlign.center; style.width(length.px 140); style.verticalAlign.middle]
                    prop.text "Start"
                  ]
                  Html.th [
                    prop.style[style.textAlign.center; style.width(length.px 140); style.verticalAlign.middle]
                    prop.text "Finish"
                  ]
                  Html.th [
                    prop.style[style.textAlign.center; style.width(length.px 140); style.verticalAlign.middle]
                    prop.text "Schedule Performance Index"
                  ]
                  Html.th [
                    prop.style[style.textAlign.center; style.width(length.px 140); style.verticalAlign.middle]
                    prop.text "Schedule Variance"
                  ]
                ]
              ]
            ]
            Html.tbody[
              match jobSchedule with
              | None ->
                yield Html.tr[
                  Html.td [
                    prop.colSpan 5
                    prop.style[ style.textAlign.center; style.padding(30, 0)]
                    prop.text "No schedule is available."
                  ]
                ]
              | Some js ->
                yield 
                  Html.tr [
                    Html.td [ prop.style[style.textAlign.center]; prop.text (showDuration js) ]
                    Html.td [ prop.style[style.textAlign.center]; prop.text (prettyPrintDateOptionShort js.Start)]
                    Html.td [ prop.style[style.textAlign.center]; prop.text (prettyPrintDateOptionShort js.Finish)]
                    Html.td [ prop.style[style.textAlign.center]; prop.text (showSPI js)]
                    Html.td [ prop.style[style.textAlign.center]; prop.text (showVariance js)]
                  ]
            ]
          ]
      ]
    ]
    
  ]

let View (model: ContractPageModel.Model) (contract: Contract)=
  loadingMessageOrContent
    "Loading Scheduling..."
    jobScheduleView
    (Map.tryFind contract.Id model.JobSchedules)
